import type {
	ICampaignConstructorParams,
	IPlanSummaryConstructorParams,
} from "@services/sdk/interfaces";

import Campaign from "./campaign";
import PlanSummaryProduct from "./plan-summary-product";

class PlanSummary {
	public static EmptyConstructorParams: IPlanSummaryConstructorParams = {
		finalPayment: {
			originalAmount: 0,
			discountedAmount: 0,
			mainBalanceAmount: 0,
			totalAmount: 0,
		},
		purchasedProducts: [],
	};

	public static Construct(params: IPlanSummaryConstructorParams): PlanSummary {
		return new PlanSummary(params);
	}

	public static ConstructEmpty(): PlanSummary {
		return new PlanSummary(PlanSummary.EmptyConstructorParams);
	}

	responseData: IPlanSummaryConstructorParams;

	constructor(params: IPlanSummaryConstructorParams) {
		this.responseData = params;
	}

	get products(): Array<PlanSummaryProduct> {
		return PlanSummaryProduct.ConstructList(
			this.responseData.purchasedProducts,
		);
	}

	get campaigns(): Array<Campaign> {
		const productCampaigns: Array<ICampaignConstructorParams> =
			this.responseData.purchasedProducts
				.filter((p) => p.campaigns)
				.map((p) => p.campaigns)
				.reduce<ICampaignConstructorParams[]>(
					(acc, cur) => [...acc, ...(cur || [])],
					[],
				);
		const totalCampaigns = this.responseData.finalPayment.campaigns || [];
		return Campaign.ConstructList([...productCampaigns, ...totalCampaigns]);
	}

	get originalPrice(): number {
		return this.responseData.finalPayment.originalAmount;
	}

	get discountedPrice(): number {
		return this.responseData.finalPayment.discountedAmount;
	}

	get totalAmount(): number {
		return this.responseData.finalPayment.totalAmount;
	}

	get promotionalText(): Array<string> {
		if (!this.responseData.finalPayment.promotionalText) {
			return [];
		}

		return this.responseData.finalPayment.promotionalText;
	}

	get walletCreditsApplied(): number {
		return this.responseData.finalPayment.mainBalanceAmount;
	}
}

export default PlanSummary;
